// removed by extract-text-webpack-plugin
module.exports = {"countriesCell":"yZPkTIjev9-vTArOYbax-","title":"_1tO9jmLYPSxzxI8xd72h8i","img":"_1uI6ptoJSRXLz0Nv9KSECa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CountryCell/CountryCell.scss
// module id = 1588
// module chunks = 0